
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import App from './App.tsx'
import './index.css'

// More aggressive cache busting solution
const preventCache = () => {
  // Add timestamp to all resources
  const cacheBuster = `v=${Date.now()}`;
  
  // Apply to stylesheets
  const links = document.querySelectorAll('link[rel="stylesheet"]');
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href) {
      link.setAttribute('href', href.includes('?') ? 
        `${href}&${cacheBuster}` : 
        `${href}?${cacheBuster}`);
    }
  });

  // Apply to scripts
  const scripts = document.querySelectorAll('script[src]');
  scripts.forEach(script => {
    const src = script.getAttribute('src');
    if (src) {
      script.setAttribute('src', src.includes('?') ? 
        `${src}&${cacheBuster}` : 
        `${src}?${cacheBuster}`);
    }
  });

  // Add meta tags to prevent caching
  const metaTags = [
    { httpEquiv: 'Cache-Control', content: 'no-store, no-cache, must-revalidate, max-age=0, post-check=0, pre-check=0' },
    { httpEquiv: 'Pragma', content: 'no-cache' },
    { httpEquiv: 'Expires', content: '0' }
  ];

  metaTags.forEach(meta => {
    // Remove existing meta tag if present
    const existingMeta = document.querySelector(`meta[http-equiv="${meta.httpEquiv}"]`);
    if (existingMeta) {
      existingMeta.remove();
    }
    
    // Add new meta tag
    const metaTag = document.createElement('meta');
    metaTag.httpEquiv = meta.httpEquiv;
    metaTag.content = meta.content;
    document.head.appendChild(metaTag);
  });
};

// Run once on initial load
preventCache();

// Also run on visibility change (when tab becomes visible again)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // Force reload the page when tab becomes visible again
    window.location.reload();
  }
});

// Add localStorage version tracking to sync between tabs
const currentVersion = Date.now().toString();
localStorage.setItem('app_version', currentVersion);

// Listen for changes in other tabs
window.addEventListener('storage', (event) => {
  if (event.key === 'app_version_change') {
    // Force reload if version changed in another tab
    window.location.reload();
  }
});

// Update version when page is being unloaded
window.addEventListener('beforeunload', () => {
  localStorage.setItem('app_version_change', currentVersion);
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <TooltipProvider>
      <App />
    </TooltipProvider>
  </BrowserRouter>
);
